export const SERVICES = {
    AI_DESIGNER: 'AI Designer',
    AI_CHAT: 'AI Chat',
    DOCUMENT: 'Document',
    DOCUMENTS: 'Documents',
    EDITOR: 'Editor',
    HEADER: 'Header',
    BILLING: 'Billing',
    ACCOUNT: 'Account',
    SIGN_IN: 'Sign in',
    TEMPLATES: 'Templates',
    TEMPLATES_MENU: 'Templates Menu',
    WORKFLOW: 'Workflow',
};
